import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ImageCarousel = ({ images }) => (
    <div className="about-image-gallery">
        <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            interval={5000}
        >
            {images.map((image, index) => (
                <div key={index}>
                    <img src={image.src} alt={image.alt} />
                </div>
            ))}
        </Carousel>
    </div>
);

export default ImageCarousel; 